import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { assignProduct, emptyProductsByZone, loadProducts, loadProductsByZone } from '../../../../store/Actions/ActionProducts';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import InputCustom from '../../../../components/elements/InputCustom';
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader';

function ListMaterial({ open, setOpen, zone_idMat, zone_id, warehouse_id, setIsAdd, setObjAdded }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const { translate } = AbstructLang()
    const [material, setMaterial] = useState('')
    const [quantity, setQuantity] = useState('')
    const [Load, setLoad] = useState(false)
    const { productsByZone, loadingProductsByZone, products, loadingProducts } = useSelectorCustom()
    useEffect(() => {
        dispatch(loadProducts())
    }, [])
    useEffect(() => {
        dispatch(loadProductsByZone(zone_idMat))
    }, [zone_idMat])
    const assign = async () => {
        const state = {
            material_id: material,
            warehouse_zone_id: zone_idMat,
            quantity: parseInt(quantity)
        }
        dispatch(assignProduct(state, setLoad))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
                dispatch(emptyProductsByZone())
            }}
            center
            classNames={{
                modal: `pop_center ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_material' >
                <br></br>
                <h2 className='add_zone' >{translate('all_materilas')}</h2>
                <div className='d-flex add_mat' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                    <div className='one-select' style={{ fontSize: "13px", width: "35%" }} >
                        <SelectDropDown
                            options={products?.map((product) => ({
                                value: product?.id, label: product?.name
                            }))}
                            varr={material}
                            setVarr={setMaterial}
                            placeholder={translate('materials')}
                        />
                    </div>
                    <input style={
                        {
                            outline: "none", border: '1px solid hsl(0, 0%, 80%)', borderRadius: "4px",
                            marginLeft: `${langLocal === 'en' && '10px'}`, padding: "0px 10px",
                            marginRight: `${langLocal === 'ar' && '10px'}`
                        }}
                        type='number' placeholder={translate('quantity')} onChange={(e) => setQuantity(e.target.value)} />

                    <button onClick={assign}
                        style={langLocal === 'ar' ? { marginRight: "10px" } : { marginLeft: "10px" }} className={`btn_top_table`} >
                        {
                            Load ? "Loading ..." : translate('add')
                        }
                    </button>
                </div>
                <div className='all_mat' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                    {
                        !loadingProductsByZone ?
                            productsByZone?.length === 0 ? <div className='no-materials' >
                                {translate('no_materials')}
                            </div> :
                                productsByZone?.map((item) => {
                                    return (
                                        <div className='one_material' key={item.id} >
                                            <span>{item?.material?.name} / {item?.quantity}</span>
                                            <i className='fa fa-trash del_zone' ></i>
                                        </div>
                                    )
                                }) : <InnerLoader />
                    }
                </div>
            </div>
        </RModal>
    )
}

export default ListMaterial